import { jsx as _jsx } from "react/jsx-runtime";
import { formatMinor, formatMinorByCurrency } from '../format.js';
/** Сумма в minor units с валютой кабинета; в таблицах — цифры моноширинно. */
export function Money({ minor, currency, }) {
    return _jsx("span", { className: "tabular-nums", children: formatMinor(minor, currency) });
}
export function MoneyByCurrency({ value }) {
    return _jsx("span", { className: "tabular-nums", children: formatMinorByCurrency(value) });
}
//# sourceMappingURL=money.js.map